import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { PluggyConnect } from 'react-pluggy-connect';
import { useSelector } from 'react-redux';
import { useSelectedAccount } from '@ibk/shared-auth';
import { config, isDevelopment, selectLastCheckedDocument } from '@ibk/shared-config';
export var PluggyWidgetConnectorType;
(function (PluggyWidgetConnectorType) {
    PluggyWidgetConnectorType["PERSONAL_BANK"] = "PERSONAL_BANK";
    PluggyWidgetConnectorType["BUSINESS_BANK"] = "BUSINESS_BANK";
})(PluggyWidgetConnectorType || (PluggyWidgetConnectorType = {}));
export const WidgetPluggy = ({ connectToken, onClose, onSuccess, connectorType, }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const [openFinanceParameters, setOpenFinanceParameters] = useState({});
    const { selectedAccount } = useSelectedAccount();
    const documentNumber = selectedAccount?.documentNumber || '';
    const lastCheckedDocument = useSelector(selectLastCheckedDocument);
    const isSandbox = ['development', 'staging'].includes(config.nodeEnv);
    useEffect(() => {
        if (connectorType === PluggyWidgetConnectorType.BUSINESS_BANK) {
            if (documentNumber && lastCheckedDocument) {
                setOpenFinanceParameters(isDevelopment() ? { cpf: lastCheckedDocument } : { cnpj: documentNumber, cpf: lastCheckedDocument });
                setIsReady(true);
            }
        }
        else if (documentNumber) {
            setOpenFinanceParameters({ cpf: documentNumber });
            setIsReady(true);
        }
    }, [documentNumber, lastCheckedDocument, connectorType]);
    return isReady ? (_jsx("div", { style: { visibility: isVisible ? 'visible' : 'hidden' }, children: _jsx(PluggyConnect, { language: 'pt', connectToken: connectToken || '', includeSandbox: isSandbox, connectorTypes: [connectorType], onOpen: () => setIsVisible(true), onClose: () => {
                setIsVisible(false);
                onSuccess();
                onClose();
            }, onSuccess: onSuccess, url: 'https://dominio.pluggy.app', openFinanceParameters: openFinanceParameters, allowConnectInBackground: true }) })) : (_jsx(_Fragment, {}));
};
